import React, {useState, useContext, useEffect} from 'react';
import { IonText, IonGrid, IonRow, IonCol, IonButton, IonModal, IonFooter, IonHeader } from '@ionic/react';

import { BookedRoomDetailsModal } from './Modal_DetailData_BookedRoom';
import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

import '../../../../css/qavaApp.css';


export function ViewBookedRoomsModal(props) {

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    //let [showInvoiceModal, setViewInvoiceModal] = useState(false);
    let [showBookedRoomDetailsModal, setBookedRoomDetailsModal] = useState(false);

    let [viewInventoryBookedRooms, setViewInventoryBookedRooms] = useState([]);

    useEffect(() => {

        if(props.openModal == true)
        {
            /*
            let formData = new FormData();
            formData.append('Tracker', 74103);
            formData.append('user', acctID);
            formData.append('xStartDateRange', props.startDate.toISOString().substr(0, 10));
            formData.append('xEndDateRange', props.endDate.toISOString().substr(0, 10));
        
            const requestOptions = {
                enctype: 'multipart/form-data',
                method:'POST',
                credentials: 'include',
                files: formData,
                body: formData,
                contentType: false,
                processData: false,
            }
            */

            const requestOptions = {
                method: 'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    //'cookie': 'cookie',
                },
                body: JSON.stringify({
                    Tracker: '74103',
                    user: acctID,
                    xStartDateRange: authenticatedMerchent_context.startDate,
                    xEndDateRange: authenticatedMerchent_context.endDate,
                    sessionID: sessionID,
    
                }),
            }
        
            
            fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
            .then(res => res.text())
            .then(res => {
        
                let rows = res.toString().split('~~~');
        
                for (let rownum = 0; rownum < rows.length - 1; ++rownum)
                {
                    let cols = rows[rownum].split('|');


                    setViewInventoryBookedRooms((prevOccupiedRooms) => {
                        return prevOccupiedRooms.concat({
                            roomID: cols[0],
                            roomType: cols[1],
                            roomDescription: cols[2],
                            roomPartNum: cols[3],
                            roomPhoneNumber: cols[4],
                            address: cols[5],
                            city: cols[6],
                            country: cols[7],
                            roomSalePrice: cols[8],
                            attachment: cols[9],
                            roomGuestFirstName: cols[10],
                            roomGuestLastName: cols[11],
                            roomGuestPhoneNumber: cols[12],
                            roomGuestPrice: cols[13],
                            roomGuestCheckInDateBooked: cols[14],
                            roomGuestCheckOutDateBooked: cols[15],
                            roomGuestInvoiceAttachment: cols[16],
                        })
                    });
                } 
            })
        }
    }, [props.openModal]);

    function closeModalHandler() {

        setViewInventoryBookedRooms([]);
        props.closeModal(false);
    }

    return (

        <React.Fragment>
            {props.openModal == true ?
            (
            <IonModal id='showBookedRooms' isOpen={ props.openModal }>

                <IonHeader className='appModalHeader'>
                         <IonText> Rooms Booked/Reserved </IonText>
                </IonHeader>
                <IonGrid class='appGridContent'>
                    <IonRow >
                            <IonCol >Room ID</IonCol>
                            <IonCol >Room Type</IonCol>
                            <IonCol >Room Phone Number</IonCol>
                            <IonCol >Guest Name</IonCol>
                            <IonCol >Guest Price (per night)</IonCol> 
                            <IonCol >Check-In - Check-Out</IonCol>                                                                               
                            <IonCol >Action</IonCol>
                    </IonRow>
                    {viewInventoryBookedRooms.map((detailData) =>   {
                        return (
                            <IonRow >
                                <IonCol >{detailData.roomID}</IonCol>
                                <IonCol >{detailData.roomType}</IonCol>
                                <IonCol >{detailData.roomPhoneNumber}</IonCol>
                                <IonCol >{detailData.roomGuestFirstName +" "+ detailData.roomGuestLastName}</IonCol>
                                <IonCol >{detailData.roomGuestPrice}</IonCol>
                                <IonCol >{detailData.roomGuestCheckInDateBooked +" - "+ detailData.roomGuestCheckOutDateBooked}</IonCol>
                                <IonCol >
                                    <BookedRoomDetailsModal openModal={ showBookedRoomDetailsModal } closeModal={() => setBookedRoomDetailsModal(false)} data={{
                                    roomID: detailData.roomID, 
                                    roomSalePrice: detailData.roomSalePrice,
                                    }}></BookedRoomDetailsModal>
                                    {/*<IonButton class='gridResultColumnButton' onClick={() => this.updateViewAttachmentModal([true, detailData.roomGuestInvoiceAttachment, detailData.roomID, detailData.roomSalePrice])}> View Invoice </IonButton>                                      
                                    <IonButton class='gridResultColumnButton' onClick={() => this.updateBookedRoomDetailsModal([true, detailData.roomID, detailData.roomSalePrice, detailData.roomGuestPhoneNumber])}> Details </IonButton>*/}  
                                    <IonButton class='gridResultColumnButton' onClick={() => setBookedRoomDetailsModal(true)}> Details </IonButton>
                                </IonCol>
                            </IonRow>
                        )
                    }
                    )}
                </IonGrid>

                <IonFooter className='modal_footer_button_center'>
                    <IonButton onClick={closeModalHandler}> Close </IonButton>
                </IonFooter>
            </IonModal>) : null }
        </React.Fragment>
    )
}